import React, { useState } from "react";
import "./EndToEndSolutions.css";

const EndToEndSolutions = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const steps = [
    {
      title: "Step 1: Strategic Planning & Engineering",
      content:
        "We begin with comprehensive feasibility assessments, site selection, and securing all necessary statutory approvals. Our expert engineers design a customized, high-efficiency Wind or Solar project plan, ensuring the foundation is legally sound and technically optimized for maximum energy generation.",
      color: "#3A954F",
    },
    {
      title: "Step 2: Turnkey Execution & Installation",
      content:
        "Leveraging the resources of the Speed Team Group, we manage procurement and construction phases. This involves sourcing quality components, executing civil works, and conducting safe, timely electrical installation of all critical infrastructure—from wind turbines and solar arrays to electrical systems—adhering to strict quality and safety standards.",
      color: "#086D36",
    },
    {
      title: "Step 3: Commissioning & Extreme Service Support",
      content:
        "The final step is connecting the plant to the grid, followed by rigorous testing and commissioning. We then hand over a fully operational asset and offer ongoing support and professional O&M (Operations & Maintenance) services, guaranteeing long-term reliability and performance optimization.",
      color: "#A1CB3A",
    },
  ];

  return (
    <section className="ees-section">
      <div className="ees-container">
        {/* LEFT TEXT */}
        <div className="ees-left">
          <h2 className="ees-title">
            ⚡ How Our <br /> End-to-End <br /> Solutions Work
          </h2>
          <p className="ees-desc">
            CM Green Energy India Private Limited provides an extreme level of
            service by offering complete, end-to-end solutions for Wind and
            Solar projects, simplifying the process into three core phases:
          </p>
        </div>

        {/* RIGHT ACCORDION */}
        <div className="ees-right">
          {steps.map((step, index) => (
            <div
              key={index}
              className="ees-card"
              style={{ backgroundColor: step.color }}
            >
              <div
                className="ees-card-header"
                onClick={() => toggle(index)}
              >
                <h3>{step.title}</h3>

                <span
                  className={
                    openIndex === index
                      ? "ees-arrow rotate"
                      : "ees-arrow"
                  }
                >
                  ^
                </span>
              </div>

              <div className={`ees-card-body ${openIndex === index ? "open" : ""}`}>
  <p>{step.content}</p>
</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EndToEndSolutions;
